import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** A single description for permissions on the snapshot level. */
interface RequiredPermissionSnapshotLevel {
  /**
   * Array filled with permissions where the user
   * should have one of them in order to have access.
   * If the array is empty, it means user has no required permission and has default access
   */
  permissions: FaroCoreApiTypes.ProjectPermission[];
}

/**
 * Object that determines all different permission rules for users to get
 * access on the snapshot level.
 */
export type RequiredPermissionsSnapshotLevel = {
  [key in RequiredPermissionSnapshotLevelName]: RequiredPermissionSnapshotLevel;
};

/** Names for all permissions within the snapshot level. */
export enum RequiredPermissionSnapshotLevelName {
  /** Whether the user can manage the snapshot (rename, delete, change access level) */
  canManageSnapshot = "canManageSnapshot",

  /** Whether the user can view all members with access to the snapshot */
  canViewAllSnapshotMembers = "canViewAllSnapshotMembers",
}
